<template>
    {{getStrRes('ML_MachineVideo')}}: 
    <a :href="link" target="_blank">
        <img src="/assets/img/icon/video.png" >
    </a>
</template>

<script>
import {getStrRes} from '../util/MultiLang.js'

const EN_STR_RES_MAP = new Map
EN_STR_RES_MAP.set("ML_MachineVideo", "Machine video")

const SPA_STR_RES_MAP = new Map
SPA_STR_RES_MAP.set("ML_MachineVideo", "Video de la máquina")

const DE_STR_RES_MAP = new Map
DE_STR_RES_MAP.set("ML_MachineVideo", "Video")

const RU_STR_RES_MAP = new Map
RU_STR_RES_MAP.set("ML_MachineVideo", "Видео о станке")

const MULTI_LANG_STR_RES_MAP = new Map
MULTI_LANG_STR_RES_MAP.set("en", EN_STR_RES_MAP)
MULTI_LANG_STR_RES_MAP.set("spa", SPA_STR_RES_MAP)
MULTI_LANG_STR_RES_MAP.set("de", DE_STR_RES_MAP)
MULTI_LANG_STR_RES_MAP.set("ru", RU_STR_RES_MAP)

export default {
    data() {
        return {
            mlStrResMap: MULTI_LANG_STR_RES_MAP
        }
    },
    props: {'link': String},
    methods: {
        getStrRes
    }
}
</script>


// WEBPACK FOOTER //
// VideoLink.vue?7ab3b4fe